import { useRef, useEffect } from 'react';
import { useIsClient } from '@fiverr-private/hooks';

interface UseCreateRootDivElementConfig {
    className?: string;
    shouldAppendToBody?: boolean;
}

/**
 * Creates a div element under the DOM root
 */
export const useCreateRootDivElement = ({
    className,
    shouldAppendToBody = true,
}: UseCreateRootDivElementConfig = {}) => {
    const domElementRef = useRef<HTMLElement>();

    const isClient = useIsClient();

    if (isClient && !domElementRef.current) {
        domElementRef.current = document.createElement('div');
        domElementRef.current.focus();

        if (className) {
            domElementRef.current.classList.add(className);
        }
    }

    useEffect(() => {
        const { current: domElement } = domElementRef;

        if (shouldAppendToBody && domElement) {
            document.body.appendChild(domElement);

            return () => {
                document.body.removeChild(domElement);
            };
        }

        return () => undefined;
    }, [shouldAppendToBody, isClient]);

    return domElementRef.current;
};
